import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { useIsNewDesign } from 'hooks/useIsNewDesign';
import { getCollectionCreator, RESTRICTED_CREATOR_FIELDS } from 'store/slices/collection/actions';

interface IPasswordPageDesign {
  isResolved: boolean;
  isNewDesign: boolean;
}

// App startup normally has the creator by the time this renders; the fetch here is the fallback
// for when that call failed. The slice seeds collectionCreator to {}, so featureFlags — not the
// object itself — is what proves a response actually landed.
export const usePasswordPageDesign = (): IPasswordPageDesign => {
  const dispatch = useAppDispatch();
  const hasFlags = useAppSelector((state) => !!state.collection.collectionCreator?.featureFlags);
  const isNewDesign = useIsNewDesign();
  const [isResolved, setIsResolved] = useState(hasFlags);

  useEffect(() => {
    if (hasFlags) {
      setIsResolved(true);

      return;
    }

    dispatch(getCollectionCreator(RESTRICTED_CREATOR_FIELDS)).finally(() => setIsResolved(true));
  }, []);

  return { isResolved, isNewDesign };
};
